import { render } from "./SortSettingsOverview.vue?vue&type=template&id=1803d7f0&scoped=true&ts=true"
import script from "./SortSettingsOverview.vue?vue&type=script&lang=ts"
export * from "./SortSettingsOverview.vue?vue&type=script&lang=ts"

import "./SortSettingsOverview.vue?vue&type=style&index=0&id=1803d7f0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1803d7f0"]])

export default __exports__